import classNames from "classnames";
import styles from "./DataPanelContent.module.css";
import { useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import CustomerServiceInnerContent from "./CustomerServiceInnerContent";
import CollectionsInnerContent from "./CollectionsInnerContent";
import BothInnerContent from "./BothInnerContent";
import { GetAccountDetailsResponse } from "../../../lib/api/models";

const strings = {
  csr: "CSR",
  coll: "COLL",
  both: "Both",
};

type DataPanelOption = "BOTH" | "COLL" | "CSR";

const options: { id: DataPanelOption; label: string }[] = [
  { id: "CSR", label: strings.csr },
  { id: "COLL", label: strings.coll },
  { id: "BOTH", label: strings.both },
];

type Props = {
  accountDetails: GetAccountDetailsResponse;
};

export default function DataPanelContent({ accountDetails }: Props) {
  const [selected, setSelected] = useState<DataPanelOption>("BOTH");

  function renderInnerContent() {
    switch (selected) {
      case "CSR":
        return <CustomerServiceInnerContent {...accountDetails.csrDataPanel} />;
      case "COLL":
        return (
          <CollectionsInnerContent
            {...accountDetails.collectionsDataPanel}
            forecastMinPayDueHoverDescription={
              accountDetails?.forecastMinPayDueHoverDescription
            }
          />
        );
      case "BOTH":
        return <BothInnerContent {...accountDetails.bothDataPanel} />;
    }
  }

  return (
    <Container>
      <Row>
        <Col xs={1} className={styles.pillButtonContainer}>
          {options.map(({ id, label }) => (
            <button
              key={id}
              className={classNames(styles.pillButton, {
                [styles.selected]: selected === id,
              })}
              onClick={() => setSelected(id)}
            >
              {label}
            </button>
          ))}
        </Col>
        {renderInnerContent()}
      </Row>
    </Container>
  );
}
